import {
  CHANGE_PRESET_RAS,
  EDIT_ALTURA_PROJECT_NUMBER,
  EDIT_LICENSE_NUMBER,
  EDIT_EAB_PROJECT_NUMBER,
  EDIT_PROJECT_NAME,
  EDIT_PROJECT_DESCRIPTION,
  EDIT_PROJECT_SCOPE,
  EDIT_PROJECT_FACILITY,
  EDIT_PROJECT_ADDRESS,
  EDIT_PROJECT_ADDRESS_2,
  EDIT_OWNER_CONTACT_NAME,
  EDIT_OWNER_NAME,
  EDIT_OWNER_ADDRESS,
  EDIT_OWNER_ADDRESS_2,
  EDIT_RAS_EMAIL,
  EDIT_RAS_NAME,
  RECEIVE_FIELDS,
  SAVE_FIELDS,
  SET_FIELD_ERRORS,
} from '../actions/actionTypes'

const singleInitialState = {
  value: "",
  state: "pristine",
  errors: [],
};

const initialState = {
  altura_project_number: { ...singleInitialState },
  license_number: { ...singleInitialState },
  eab_project_number: { ...singleInitialState },
  project_name: { ...singleInitialState },
  project_description: { ...singleInitialState },
  project_scope: { ...singleInitialState },
  project_facility: { ...singleInitialState },
  project_address: { ...singleInitialState },
  project_address_2: { ...singleInitialState },
  owner_contact_name: { ...singleInitialState },
  owner_name: { ...singleInitialState },
  owner_address: { ...singleInitialState },
  owner_address_2: { ...singleInitialState },
  ras_email: { ...singleInitialState },
  ras_name: { ...singleInitialState },
}

const tdlrFileds = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PRESET_RAS:
      return {
        ...state,
        ras_email: {
          value: action.value.ras_email,
          state: 'pristine',
          errors: [],
        },
        ras_name: {
          value: `${action.value.firstname} ${action.value.lastname}`,
          state: 'pristine',
          errors: [],
        },
        license_number: {
          value: action.value.ras_number,
          state: 'pristine',
          errors: [],
        }
      };
    case EDIT_ALTURA_PROJECT_NUMBER:
      return {
        ...state,
        altura_project_number: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_LICENSE_NUMBER:
      return {
        ...state,
        license_number: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_EAB_PROJECT_NUMBER:
      return {
        ...state,
        eab_project_number: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_PROJECT_NAME:
      return {
        ...state,
        project_name: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_PROJECT_DESCRIPTION:
      return {
        ...state,
        project_description: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_PROJECT_SCOPE:
      return {
        ...state,
        project_scope: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_PROJECT_FACILITY:
      return {
        ...state,
        project_facility: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_PROJECT_ADDRESS:
      return {
        ...state,
        project_address: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_PROJECT_ADDRESS_2:
      return {
        ...state,
        project_address_2: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_OWNER_CONTACT_NAME:
      return {
        ...state,
        owner_contact_name: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_OWNER_NAME:
      return {
        ...state,
        owner_name: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_OWNER_ADDRESS:
      return {
        ...state,
        owner_address: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_OWNER_ADDRESS_2:
      return {
        ...state,
        owner_address_2: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_RAS_EMAIL:
      return {
        ...state,
        ras_email: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case EDIT_RAS_NAME:
      return {
        ...state,
        ras_name: {
          value: action.value,
          state: "dirty",
          errors: action.errors,
        }
      };
    case RECEIVE_FIELDS:
      return Object.getOwnPropertyNames(action.fields).reduce((acc, curr) => {
        acc[curr] = {
          value: action.fields[curr],
          state: "pristine",
          errors: [],
        }
        return acc;
      }, {});
    case SAVE_FIELDS:
      return Object.getOwnPropertyNames(state).reduce((acc, curr) => {
        acc[curr] = {
          value: state[curr].value,
          state: "dirty",
          errors: state[curr].errors,
        }
        return acc;
      }, {});
    case SET_FIELD_ERRORS:
      return state;
    default:
      return state;
  }
};

export default tdlrFileds;